export default __webpack_public_path__ + "static/media/Pesky.7efdf15c.png";